import { Component } from '@angular/core';
import { AppBarTitleService, SsoAccountFacade } from 'common';
import { ReferralCodeBaseComponent } from './referral-code-base.component';
import { ReminderService } from '../reminder/reminder.service';
import { ReminderData, Reminders } from '../reminder/reminder.model';
import { EntityFacade } from '../entity/domain/+state/entity.facade';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'ifp-referral-code-reminder',
    templateUrl: './referral-code.component.html',
    styleUrls: ['./referral-code.component.scss'],
    standalone: false
})
export class ReferralCodeReminderComponent extends  ReferralCodeBaseComponent<ReminderData> {

  constructor(
    appBarTitleService: AppBarTitleService,
    reminderService: ReminderService,
    entityFacade: EntityFacade,
    route: ActivatedRoute,
    ssoAccountFacade: SsoAccountFacade
  ) {
    super(appBarTitleService, reminderService, entityFacade, route, ssoAccountFacade);
    this._searchCondition = { name: Reminders.Referral }
    sessionStorage.setItem('referralPageViewed', JSON.stringify(true));
  }
}
